import { Fragment, Slice, Node } from 'prosemirror-model';
import { Plugin, PluginKey } from 'prosemirror-state';
import { LINK_VALIDATION } from '../link-validation.const';

const linkValidationRegex = RegExp(LINK_VALIDATION);

const linkOnPaste = (fragment: Fragment): Fragment => {
    const nodes: Node[] = [];

    fragment.forEach((child: Node) => {
        if (!child.isText) {
            nodes.push(child.copy(linkOnPaste(child.content)));
            return;
        }

        let match: RegExpMatchArray | null;
        while ((match = linkValidationRegex.exec(child.text))) {
            const start = match.index;
            const end = start + match[0].length;
            const { link } = child.type.schema.marks;

            // Add the text before the link
            if (start > 0) {
                nodes.push(child.cut(0, start));
            }

            // Add the link
            const urlText = child.text.slice(start, end);
            nodes.push(child.cut(start, end).mark(link.create({ href: urlText }).addToSet(child.marks)));

            if (child.text.length === end) {
                return;
            }

            child = child.cut(end);
        }

        // Add the remaining text
        if (child.text.length) {
            nodes.push(child);
        }
    });

    return Fragment.fromArray(nodes);
};

export class LinkPlugin extends Plugin {
    constructor() {
        super({
            key: new PluginKey('link-plugin'),
            props: {
                transformPasted: (slice: Slice) => {
                    return new Slice(linkOnPaste(slice.content), slice.openStart, slice.openEnd);
                }
            }
        });
    }
}
